import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { LanguageService } from "src/app/shared/services/language.service";
import { CustomI18nTranslateLoader } from "./customI18nLoader";

@NgModule({
  declarations: [],
  imports: [
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomI18nTranslateLoader,
        deps: [LanguageService],
      },
    }),
  ],
  providers: [],
  exports: [TranslateModule],
})
export class CommonTranslateModule {
  // Do not include a constructor in a module; otherwise, it will short-circuit Angular's initialization flow at the initialization stage.
}
